import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  section: {
    padding: '124px 0',
    maxWidth: 1024,
    margin: '0 auto',
    fontSize: 24,
    [theme.breakpoints.down('sm')]: {
      padding: '82px 20px',
    },
  },
  title: {
    fontFamily: 'sofia-bold, sans-serif',
    marginBottom: 64,
  },
  subtitleText: {
    color: '#9B9B9B',
    fontSize: 18,
  },
  card: {
    padding: '10px',
    textAlign: 'center',
  },
  cardHeading: {
    color: '#241e3f',
    fontFamily: 'sofia-bold, sans-serif',
    fontSize: 24,
    margin: '12px 0',
  },
  cardDescription: {
    fontSize: 16,
    lineHeight: '24px',
  },
  button: {
    width: '90%',
    height: 56,
    borderRadius: 28,
    textTransform: 'uppercase',
    fontSize: 18,
    margin: 16,
  },
});

export default makeStyles(styles);
